import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useEnabledStaffs } from "~/hooks/useStaffs";
import type { DealSearchCondition } from "~/models/Deal";
import type { Staff } from "~/models/Staff";

export function StaffCombobox() {
	const staffs = useEnabledStaffs().data;
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const watchedStaffId = useWatch({ control, name: "staffId" });

	const selectedStaffOption = useMemo(():
		| ComponentProps<typeof SingleComboBox>["value"]
		| null => {
		const staff = staffs?.find(({ id }) => id === watchedStaffId) || null;
		return staff
			? {
					label: staff.name,
					value: String(staff.id)
				}
			: null;
	}, [staffs, watchedStaffId]);

	const onStaffChange = useCallback(
		async (
			option: ComponentProps<typeof SingleComboBox>["value"] | null
		): Promise<void> => {
			setValue("staffId", option ? Number(option.value) : undefined);
		},
		[setValue]
	);
	if (staffs === null) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onStaffChange}
			options={staffs.map((c: Staff) => ({
				label: c.name,
				value: String(c.id)
			}))}
			placeholder="担当者"
			value={selectedStaffOption}
		/>
	);
}
